import styled, { css } from 'styled-components';

import { A11yHidden, MQ } from '@rover/kibble/styles';
import DateRangePicker, {
  IconWrapper,
  MobileLabel,
  Props as DateRangePickerProps,
} from '@rover/react-lib/src/components/datetime/DateRangePicker';

export type Props = DateRangePickerProps & {
  inline?: boolean;
  hideInputsOnMobile?: boolean;
};

const StyledDateRangePicker = styled(DateRangePicker)<Props>`
  ${MobileLabel} {
    ${A11yHidden};
  }
  display: flex;
  flex-direction: column;
  ${IconWrapper} {
    display: none;
  }

  ${(props) =>
    props.hideInputsOnMobile
      ? css`
          display: none;
          ${MQ.SM_UP.toString()} {
            display: flex;
          }
        `
      : ''}

  .form-group {
    padding-bottom: 8px;
  }

  ${(props) =>
    props.inline
      ? css`
          ${IconWrapper} {
            display: flex;
          }
          flex: 1 1 60%;
          flex-direction: row;
        `
      : ''}

  ${MQ.SM_UP.toString()} {
    ${(props) =>
      props.inline
        ? css`
            .form-group {
              padding-bottom: 0px;
            }
          `
        : css`
            .form-group {
              padding-bottom: 4px;
            }
          `}
  }
`;

export default StyledDateRangePicker;
